import React from "react";
import StageId from "./components/StageContainer/StageId";
import LazyComponent from "venuescanner-js/react/components/LazyComponent";
import { Flavour, venueFinderFlavours } from "./constants";
import { getStyles } from "venuescanner-js/services/tagService";

export default ({
  user,
  phone,
  flavour,
  base,
  isCorporate = false,
  Welcome,
}) => {
  const isLoggedIn = (user && phone) || false;

  // const shouldRedirectToSrp below commented out as we want to capture the user contact details at all times
  // left here just incase it is is needed in the future
  // const shouldRedirectToSrp = flavour === Flavour.VENUE_SEARCH || (venueFinderFlavours.includes(flavour) && !isCorporate)

  const stageEntries = [
    [StageId.Welcome, Welcome],
    [
      StageId.InitialEventDetails,
      new LazyComponent(() =>
        import("./components/stages/InitialEventDetailsStage")
      ),
    ],
    [
      StageId.GuestsAndLayout,
      new LazyComponent(() =>
        import("./components/stages/GuestsAndLayoutStage")
      ),
    ],
    [
      StageId.StylesAndCatering,
      new LazyComponent(async () => {
        // Lazily load the styles at the same time as the StylesAndCateringStage
        const [{ default: StylesAndCateringStage }, styleTags] =
          await Promise.all([
            import("./components/stages/StylesAndCateringStage"),
            getStyles(base),
          ]);
        return {
          default: (props) => (
            <StylesAndCateringStage styles={styleTags} {...props} />
          ),
        };
      }),
    ],
    [
      StageId.BudgetAndCorpOrPrivate,
      new LazyComponent(() =>
        import("./components/stages/BudgetAndCorpOrPrivateStage")
      ),
    ],
    !isLoggedIn && [
      StageId.UserDetails,
      new LazyComponent(() => import("./components/stages/UserDetailsStage")),
    ],
    [
      StageId.ThankYou,
      new LazyComponent(() => import("./components/stages/ThankYouStage")),
    ],
  ].filter(Boolean);
  return new Map(stageEntries);
};
